export const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000';
export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';